import { cva, css } from '../../../../styled-system/css';

const loadingModal = cva({
  base: {
    alignContent: 'center',
    display: 'flex',
    justifyContent: 'center',
  },

  variants: {
    delayed: {
      true: {
        animation: 'delayIn',
      },
    },
    size: {
      fullscreen: {
        backgroundColor: 'overlayBg',
        bottom: '0',
        left: '0',
        position: 'fixed',
        right: '0',
        top: '0',
      },
      contained: {
        width: 'full',
        height: 'full',
      },
    },
  },

  defaultVariants: {
    delayed: false,
    size: 'fullscreen',
  },
});

const loadingAnimation = cva({
  base: {
    animation: 'maze',
    aspectRatio: '[1]',
    background: `[
      radial-gradient(farthest-side, token(colors.loadingFg) 90%, #0000) 0 0/8px 8px no-repeat,
      conic-gradient(from -90deg at 30px 30px, #0000 90deg, token(colors.loadingBg) 0) 0 0/40px 40px ,
      conic-gradient(from  90deg at 10px 10px, #0000 90deg, token(colors.loadingBg) 0) 0 0/40px 40px no-repeat,
      conic-gradient(from -90deg at 30px 30px, #0000 90deg, token(colors.loadingBg) 0) 100% 100%/40px 40px no-repeat;]`,
    width: '[100%]',
  },
});

export interface LoadingModalProps {
  delayed?: boolean;
  size?: 'fullscreen' | 'contained';
}

export const LoadingModal = ({
  delayed = false,
  size = 'fullscreen',
}: LoadingModalProps) => {
  return (
    <div className={loadingModal({ delayed, size })}>
      <div
        className={css({
          aspectRatio: '[1]',
          margin: 'auto',
          width: '[70px]',
        })}
      >
        <div className={loadingAnimation()} />
      </div>
    </div>
  );
};
